export function openNewTab(url: string) {
  window.open(url.toString(), '_blank');
}
